import React from "react";
import { Tag } from "antd";
import moment from "moment";

export const renderMoreHtmlDec = (record, modelName, dispatch) => {
  var html = record;
  var div = document.createElement("div");
  div.innerHTML = html;
  var text = div.textContent || div.innerText || "";

  if (text.length > 65) {
    return (
      <span
        className="gx-text-primary gx-link"
        onClick={() => {
          dispatch({
            type: "Show_Modal",
            payload: record,
            ModalName: modelName,
          });
        }}
      >
        Read more
      </span>
    );
  } else {
    return "";
  }
};
export const renderStatus = (status) => {
  if (status === "active") {
    return <Tag color="green">Active</Tag>;
  }
  if (status === "block") {
    return <Tag color="red">Block</Tag>;
  }
  if (status === "invite") {
    return <Tag color="blue">Invite</Tag>;
  }
  if (status === "reinvite") {
    return <Tag color="blue">Invite</Tag>;
  }
  if (status === "pending") {
    return <Tag color="blue">Inactive</Tag>;
  }
  if (status === "deleted") {
    return <Tag color="red">Delete</Tag>;
  }
  if (status === "publish") {
    return <Tag color="green">Publish</Tag>;
  } else {
    return <Tag color="green">Publish</Tag>;
  }
};
export const renderTiming = (timing) => {
  return (
    timing &&
    timing.length > 0 &&
    timing.map((item) => {
      return (
        <div>
          <span>{item.duration && item.duration}</span> -{" "}
          <span>{item.type && item.type}</span>
          <p>
            {item.exercise && item.exercise.length > 20
              ? item.exercise.substring(0, 30) + "..."
              : item.exercise}
          </p>
        </div>
      );
    })
  );
};
export const renderSubstring = (data, length, subtract) => {
  return (
    <span>{data > length ? data.substring(0, subtract) + "..." : data}</span>
  );
};
export const renderArticle = (record, length = 100, alpha = 65) => {
  var html = record;
  var div = document.createElement("div");
  div.innerHTML = html;
  var text = div.textContent || div.innerText || "";
  let substring =
    text && text.length > length ? text.slice(0, alpha) + "..." : text;
  return substring;
  // return element.slice(0,65)
};
export const renderDate = (date, format = "MMMM Do YYYY") => {
  return moment(date).format(format);
};
export const renderSubCategoryName = (data) => {
  let categoryId = data.category;

  let categoryName = "";
  if (categoryId && categoryId.length > 1) {
    console.log("===if======", categoryId);
    categoryId.map((Item, index) => {
      if (index > 0) {
        // if (categoryName === "") {
        //   if (children[Item].name) {
        //     console.log("=====empty====", categoryName, Item, children[Item]);
        //     categoryName = children[Item] && children[Item].name + "/ ";
        //   }
        //   if (children[Item].children) {
        //     children = children[Item] && children[Item].children;
        //     console.log("====== children =====", children);
        //   }
        // }
        //  else if (categoryId.length - 1 === index) {
        //   if (children[Item].name) {
        //     console.log("====eq=====", categoryName, Item, children[Item]);
        //     categoryName =
        //       categoryName + (children[Item] && children[Item].name);
        //   }
        // }
        // else {
        //   if (children[Item].name) {
        //     console.log("====else=====", categoryName, Item, children[Item]);
        //     categoryName =
        //       categoryName + children[Item] && children[Item].name + "/ ";
        //   }
        //   if (children[Item].children) {
        //     children = children[Item] && children[Item].children;
        //     console.log("====== children =====", children);
        //   }
        // }
      } else {
        categoryName = "";
      }
      return Item;
    });
  }

  if (categoryName === "") {
    categoryName = "---";
  }

  return categoryName;
};
export const showModal = (dispatch, record, modelName) => {
  dispatch({
    type: "Show_Modal",
    payload: record,
    ModalName: modelName,
  });
};
